// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__344eD","label":"CategoryService_label__hnm1n","location":"CategoryService_location__3en91"};